import React from "react";
import Card from "components/card";
import PieChart from "components/charts/PieChart";

const SODDistributionChart = ({ data, title = "Generations Distributions" }) => {
  if (!data || data.length === 0) {
    return (
      <Card extra="p-4">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white mb-4 font-dm">
          {title}
        </h4>
        <div className="flex items-center justify-center h-64">
          <p className="text-gray-500 dark:text-gray-400">No data available</p>
        </div>
      </Card>
    );
  }

  // Aggregate data into two categories: Edits and Creations
  const editsCount = data.find(item => item.edit === 0)?.count || 0;
  const creationsCount = data.find(item => item.edit === -1)?.count || 0;
  
  const chartData = [
    { name: "Edits", value: parseInt(editsCount) },
    { name: "Creations", value: parseInt(creationsCount) }
  ];

  const labels = ["Edits", "Creations"];

  return (
    <Card extra="p-4">
      <h4 className="text-lg font-bold text-navy-700 dark:text-white mb-4 font-dm">
        {title}
      </h4>
      <PieChart
        series={chartData.map(item => item.value)}
        options={{
          labels: labels,
          colors: ["#6AD2FF", "#FF9A8B"],
          chart: {
            width: "100%",
            height: 300,
            fontFamily: "DM Sans, sans-serif"
          },
          states: {
            hover: {
              filter: {
                type: "none",
              },
            },
            active: {
              filter: {
                type: "none",
              },
            },
          },
        }}
      />
    </Card>
  );
};

export default SODDistributionChart; 